const config = {
  'dev': {
    'jinfm': {
      apiKey: "AIzaSyCrCBTgXe9s7L0CHVBH5oXuh7ZzqTt0BbI",
      authDomain: "agent-jinfm-test-abgqrt.firebaseapp.com",
      databaseURL: "https://agent-jinfm-test-abgqrt.firebaseio.com",
      projectId: "agent-jinfm-test-abgqrt",
      storageBucket: "agent-jinfm-test-abgqrt.appspot.com",
      messagingSenderId: "349721501219",
      appId: "1:349721501219:web:deb538c6021da59212db96"
    },
    'eip': {
      apiKey: "AIzaSyDAPl5Neiufs7UI4G08hkIwUxfm9xGOcSE",
      authDomain: "agent-eip-test-exsmso.firebaseapp.com",
      databaseURL: "https://agent-eip-test-exsmso.firebaseio.com",
      projectId: "agent-eip-test-exsmso",
      storageBucket: "agent-eip-test-exsmso.appspot.com",
      messagingSenderId: "1078107881724",
      appId: "1:1078107881724:web:dfaab0a2b77fa132801779"
    },
    'udesign': {
      apiKey: "AIzaSyAbZMJ_9QB65NZ4_SwMmIz8SX_SxoTZ96s",
      authDomain: "agent-udnfunlife-test-dwmo.firebaseapp.com",
      projectId: "agent-udnfunlife-test-dwmo",
      storageBucket: "agent-udnfunlife-test-dwmo.appspot.com",
      messagingSenderId: "778432455449",
      appId: "1:778432455449:web:a19a05595a049d5225db88",
      measurementId: "G-4G976QM3N0"
    },
    'utravel': {
      apiKey: "AIzaSyC0yxef32a1CNhV75DYnsq37iKpK7NFbhY",
      authDomain: "agent-utravel-test-kukmrl.firebaseapp.com",
      databaseURL: "https://agent-utravel-test-kukmrl.firebaseio.com",
      projectId: "agent-utravel-test-kukmrl",
      storageBucket: "agent-utravel-test-kukmrl.appspot.com",
      messagingSenderId: "644569828594",
      appId: "1:644569828594:web:cbe33250a1acb7b8a7946b"
    },
    'health': {
      apiKey: "AIzaSyA8g2409nsBDN9gLU69DFhKGux1CtlmmYs",
      authDomain: "agent-health-test-yira.firebaseapp.com",
      projectId: "agent-health-test-yira",
      storageBucket: "agent-health-test-yira.appspot.com",
      messagingSenderId: "566085779720",
      appId: "1:566085779720:web:9985e46dc1084c7cea2cbd",
      measurementId: "G-L8PTGW5M0W"
    },
    'tickets': {
      apiKey: "AIzaSyAI_nJyMDw8e3spiVgmYeYOD70jBy3b0KQ",
      authDomain: "agent-tickets-uryf.firebaseapp.com",
      projectId: "agent-tickets-uryf",
      storageBucket: "agent-tickets-uryf.appspot.com",
      messagingSenderId: "940569166585",
      appId: "1:940569166585:web:601731dd686a3c176b9828",
      measurementId: "G-PTJBB3QZTQ"
    }
  },
  'prod': {
    'jinfm': {
      apiKey: "AIzaSyAJgnMBCDrzK97qqjOp88hkk4GQ5Wid0Rk",
      authDomain: "agent-jinfm-ivadpv.firebaseapp.com",
      databaseURL: "https://agent-jinfm-ivadpv.firebaseio.com",
      projectId: "agent-jinfm-ivadpv",
      storageBucket: "agent-jinfm-ivadpv.appspot.com",
      messagingSenderId: "980028597884",
      appId: "1:980028597884:web:2873c2d0be56a951bacbf9"
    },
    'eip': {
      apiKey: "AIzaSyDDv1MVxBNo90HgzeBk5TxgT7GOoT4ul_c",
      authDomain: "agent-eip-xdgvwc.firebaseapp.com",
      databaseURL: "https://agent-eip-xdgvwc.firebaseio.com",
      projectId: "agent-eip-xdgvwc",
      storageBucket: "agent-eip-xdgvwc.appspot.com",
      messagingSenderId: "770446744507",
      appId: "1:770446744507:web:e21532fa88694be234029e"
    },
    'udesign': {
      apiKey: "AIzaSyC-Oq81T1vIHLysbLVPLAJRN_T_iIEm2Ko",
      authDomain: "agent-udnfunlife-cysl.firebaseapp.com",
      projectId: "agent-udnfunlife-cysl",
      storageBucket: "agent-udnfunlife-cysl.appspot.com",
      messagingSenderId: "653828795172",
      appId: "1:653828795172:web:d7727ae6cb9c5bb882e1b1",
      measurementId: "G-CFS3YEKBF0"
    },
    'utravel': {
      apiKey: "AIzaSyAI2onPnbjbJlC5ZPd6Hlb-Lzg8poKLQQw",
      authDomain: "agent-utravel-ylkcto.firebaseapp.com",
      databaseURL: "https://agent-utravel-ylkcto.firebaseio.com",
      projectId: "agent-utravel-ylkcto",
      storageBucket: "agent-utravel-ylkcto.appspot.com",
      messagingSenderId: "916436880985",
      appId: "1:916436880985:web:f8fdbd3ec9a5b3fea3eb48"
    },
    'tickets': {
      apiKey: "AIzaSyAI_nJyMDw8e3spiVgmYeYOD70jBy3b0KQ",
      authDomain: "agent-tickets-uryf.firebaseapp.com",
      projectId: "agent-tickets-uryf",
      storageBucket: "agent-tickets-uryf.appspot.com",
      messagingSenderId: "940569166585",
      appId: "1:940569166585:web:601731dd686a3c176b9828",
      measurementId: "G-PTJBB3QZTQ"
    },
    'health': {
      apiKey: "AIzaSyBcVp78Q9RFqjb4Gj6XT6ZYCSkbL6k16jo",
      authDomain: "agent-health-o9qr.firebaseapp.com",
      projectId: "agent-health-o9qr",
      storageBucket: "agent-health-o9qr.firebasestorage.app",
      messagingSenderId: "813713879494",
      appId: "1:813713879494:web:f7304b48577731d86f82c7",
      measurementId: "G-V85B79GXG2"
    }
  }
}

module.exports = config


// WEBPACK FOOTER //
// ./src/pages/js/firebaseConfigs.js